// OK - Error CORS
// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

const API_URL_DEVELOPMENT = "https://api.amigogroup.id/poin-gifts/history-gift-poins";
const API_URL_PRODUCTION = "https://backend.amigogroup.net/poin-gift/api/history-gift-poins";

export default class SetupPoinAPIService {
  constructor() {}
  config = this.$session.get("jwt");

  static getURL = () => {
    return Properties.BUILD_TYPE == "production" ? API_URL_PRODUCTION : API_URL_DEVELOPMENT;
  }

  static get = (body) =>{
    return apiClient.get(this.getURL() + "/", {
      params: body,
    });
  }
  static ambil = (body, kode) =>{
    return apiClient.put(this.getURL() + "/ambil-gift/" +kode, body);
  }
}
